import {
  BILL,
  CANCELED,
  ERROR,
  FINISH,
  IN_PROGRESS,
  NEED_TO_CHECK,
  PLACED,
  REGISTRY_COMPLETED,
  REPAY,
  SKIPED,
  TIMEOUT_CANCEL,
  VERIFIED,
  WAIT_CONFIRMATION,
  WAIT_CVV,
  WAIT_OTP,
  WAIT_SUPPORT_CONFIRMATION,
  WAIT_USER_REGISTRATION,
  REGISTRY_READY,
} from "@js-app/const/operation-statuses-ids";
import { CANCEL_PRE_AUTHORIZATION } from "@js-app/const/operation-types-ids";

export const STATUSES_GROUPS = {
  skipped: {
    id: "skipped",
    name: `operation-statuses.skipped`,
    shortName: `operation-statuses.skipped-short`,
    color: "#414753",
    markBackgroundColor: "#414753",
    backgroundColor: "#EBEBEB",
    statuses: [SKIPED],
  },
  verified: {
    id: "verified",
    name: `operation-statuses.verified`,
    shortName: `operation-statuses.verified-short`,
    color: "#7096B9",
    markBackgroundColor: "#7096B9",
    backgroundColor: "#BADEFF",
    statuses: [VERIFIED],
  },
  pending: {
    id: "pending",
    name: `operation-statuses.pending`,
    shortName: `operation-statuses.pending-short`,
    color: "#C9924F",
    markBackgroundColor: "#C9924F",
    backgroundColor: "#FFD29C",
    statuses: [
      IN_PROGRESS,
      NEED_TO_CHECK,
      WAIT_CONFIRMATION,
      WAIT_CVV,
      WAIT_OTP,
      WAIT_SUPPORT_CONFIRMATION,
      WAIT_USER_REGISTRATION,
      BILL,
      REPAY,
    ],
  },
  success: {
    id: "success",
    name: `operation-statuses.success`,
    shortName: `operation-statuses.success-short`,
    color: "#55A575",
    markBackgroundColor: "#55A575",
    backgroundColor: "#DBFFC3",
    statuses: [FINISH],
  },
  error: {
    id: "error",
    name: `operation-statuses.error`,
    shortName: `operation-statuses.error-short`,
    color: "#B84F4F",
    markBackgroundColor: "#B84F4F",
    backgroundColor: "#FFBDBD",
    statuses: [ERROR],
  },
  cancel: {
    id: "cancel",
    name: `operation-statuses.cancel`,
    shortName: `operation-statuses.cancel-short`,
    color: "#B84F4F",
    markBackgroundColor: "#B84F4F",
    backgroundColor: "#FFBDBD",
    statuses: [CANCELED, TIMEOUT_CANCEL, CANCEL_PRE_AUTHORIZATION],
  },
  created: {
    id: "created",
    name: `operation-statuses.created`,
    shortName: `operation-statuses.created-short`,
    color: "#7096B9",
    markBackgroundColor: "#7096B9",
    backgroundColor: "#BADEFF",
    statuses: [PLACED],
  },
};

export const STATUSES_GROUPS_EXTENDED = {
  skipped: {
    id: "skipped",
    name: `operation-statuses.skipped`,
    shortName: `operation-statuses.skipped-short`,
    color: "#414753",
    markBackgroundColor: "#414753",
    backgroundColor: "#EBEBEB",
    statuses: [SKIPED],
  },
  verified: {
    id: "verified",
    name: `operation-statuses.verified`,
    shortName: `operation-statuses.verified-short`,
    color: "#7096B9",
    markBackgroundColor: "#7096B9",
    backgroundColor: "#BADEFF",
    statuses: [VERIFIED],
  },
  pending: {
    id: "pending",
    name: `operation-statuses.pending`,
    shortName: `operation-statuses.pending-short`,
    color: "#C9924F",
    markBackgroundColor: "#C9924F",
    backgroundColor: "#FFD29C",
    statuses: [
      IN_PROGRESS,
      NEED_TO_CHECK,
      WAIT_CONFIRMATION,
      WAIT_CVV,
      WAIT_OTP,
      WAIT_SUPPORT_CONFIRMATION,
      WAIT_USER_REGISTRATION,
      BILL,
      REPAY,
    ],
  },
  registry_ready: {
    id: "registry_ready",
    name: `operation-statuses.registry_ready`,
    shortName: `operation-statuses.registry_ready-short`,
    color: "#C9924F",
    markBackgroundColor: "#C9924F",
    backgroundColor: "#FFD29C",
    statuses: [REGISTRY_READY],
  },
  success: {
    id: "success",
    name: `operation-statuses.success`,
    shortName: `operation-statuses.success-short`,
    color: "#55A575",
    markBackgroundColor: "#55A575",
    backgroundColor: "#DBFFC3",
    statuses: [FINISH],
  },
  error: {
    id: "error",
    name: `operation-statuses.error`,
    shortName: `operation-statuses.error-short`,
    color: "#B84F4F",
    markBackgroundColor: "#B84F4F",
    backgroundColor: "#FFBDBD",
    statuses: [ERROR],
  },
  cancel: {
    id: "cancel",
    name: `operation-statuses.cancel`,
    shortName: `operation-statuses.cancel-short`,
    color: "#B84F4F",
    markBackgroundColor: "#B84F4F",
    backgroundColor: "#FFBDBD",
    statuses: [CANCELED, TIMEOUT_CANCEL, CANCEL_PRE_AUTHORIZATION],
  },
  created: {
    id: "created",
    name: `operation-statuses.created`,
    shortName: `operation-statuses.created-short`,
    color: "#7096B9",
    markBackgroundColor: "#7096B9",
    backgroundColor: "#BADEFF",
    statuses: [PLACED],
  },
  completed: {
    id: "completed",
    name: `operation-statuses.completed`,
    shortName: `operation-statuses.completed-short`,
    color: "#55A575",
    markBackgroundColor: "#55A575",
    backgroundColor: "#DBFFC3",
    statuses: [REGISTRY_COMPLETED],
  },
};
